import { get } from 'lodash';
import { notifySuccess, notifyError } from './common';
import {
    defaultState as baseState,
    mutations as baseMutations,
    actions as baseActions
} from './searchBase';

const defaultState = {
    entityName: 'settings',
    tableName: 'settingsTable',
    ...baseState,
    rebootTimes: [],
    helpUrl: '/user-guide/guide/settings.html'
};

const mutations = {
    ...baseMutations,
    setRebootTimes(state, value) {
        state.rebootTimes = Array.isArray(value) ? value : [];
    }
};

const actions = {
    ...baseActions,
    fetchSettingsOptions({ commit, state }) {
        console.log('calling fetchSettingsOptions');
        if (Object.keys(state.optionsConfig).length) {
            const rebootTimes =
                get(state.optionsConfig, 'rebootTimeOptions') || [];
            commit('setRebootTimes', rebootTimes);
        }
    },
    updateVenueEntity(
        { dispatch },
        { oldVenue, newVenue, oldChannelMaps, newChannelMaps }
    ) {
        console.log('calling updateVenueEntity');
        const successMessage = 'Venue setings has been saved successfuly';
        const failMessage = 'Error occured while saving this venue settings...';
        dispatch('notifier/requestPending', null, { root: true });
        return dispatch(
            'venue/updateVenue',
            { oldVenue, newVenue },
            { root: true }
        )
            .then(() => {
                return dispatch(
                    'channelMaps/updateDefaultChannels',
                    {
                        oldChannelMaps,
                        newChannelMaps
                    },
                    { root: true }
                );
            })
            .then(() => {
                notifySuccess(dispatch, successMessage);
            })
            .catch(error => {
                notifyError(dispatch, failMessage, error);
            })
            .finally(() => {
                dispatch('notifier/reset', null, { root: true });
            });
    }
};

export default {
    namespaced: true,
    state: defaultState,
    mutations,
    actions
};
